import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  ModalConfirmationContainer,
  ModalConfirmationHeaderNoClose,
  ModalConfirmationFooter,
  ModalConfirmationContent,
  ModalActions,
} from '../../components/modal';
import { BrandButton } from '../../components/button';
import { cleanUrlFromParameters } from '../../utils/url-utils/urlUtils';

type Props = {
  closeModal: () => void;
  isOpen: boolean;
};

export const SetPasswordErrorModal: FC<Props> = ({ isOpen, closeModal }) => {
  const onValidation = () => {
    cleanUrlFromParameters();
    closeModal();
  };

  return (
    <ModalConfirmationContainer
      isOpen={isOpen}
      onRequestClose={onValidation}
      shouldCloseOnOverlayClick={false}
    >
      <ModalConfirmationHeaderNoClose
        title={<FormattedMessage id="SetPasswordErrorModal/1" />}
      />
      <form onSubmit={onValidation}>
        <ModalConfirmationContent>
          <p>
            <FormattedMessage id="SetPasswordErrorModal/2" />
          </p>
        </ModalConfirmationContent>
        <ModalConfirmationFooter>
          <ModalActions>
            <BrandButton type="submit">
              <FormattedMessage id="SetPasswordErrorModal/3" />
            </BrandButton>
          </ModalActions>
        </ModalConfirmationFooter>
      </form>
    </ModalConfirmationContainer>
  );
};
